import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ activePage, environment, onEnvironmentChange }) => {
  const { user, isAuthenticated, logout, authRequired } = useAuth();
  const getPageTitle = () => {
    const titles = {
      dashboard: 'Dashboard Overview',
      executions: 'Executions',
      sync: 'Sync Status',
      companies: 'Companies',
      contacts: 'Contacts',
      opportunities: 'Opportunities',
      quotes: 'Quotes',
      'quote-association-gaps': 'Quote Association Gaps',
      errors: 'Errors',
      analytics: 'Analytics',
      settings: 'Settings',
      'field-mappings': 'Field Mappings',
      'default-values': 'Default Values',
      'value-mappings': 'Value Mappings',
      'lookup-mappings': 'Lookup Mappings',
      'sync-config': 'Sync Overview'
    };
    return titles[activePage] || 'Dashboard';
  };

  const getHeaderActions = () => {
    if (activePage === 'contacts') {
      return (
        <>
          <button className="btn btn-secondary">Export</button>
          <button className="btn btn-secondary">Resync All</button>
        </>
      );
    }
    if (activePage === 'companies') {
      return (
        <>
          <button className="btn btn-secondary">Export</button>
          <button className="btn btn-secondary">Resync All</button>
        </>
      );
    }
    return null;
  };

  return (
    <div className="header">
      <h1>{getPageTitle()}</h1>
      <div className="header-actions">
        {/* The quote association audit and mapping actions are production-only. */}
        {activePage === 'quote-association-gaps' ? (
          <div className="environment-toggle environment-locked" aria-label="Production data only">
            <span aria-hidden="true">🔒</span>
            <span className="env-label active">Production data only</span>
          </div>
        ) : (
          <div className="environment-toggle">
            <span className={`env-label ${environment === 'sandbox' ? 'active' : ''}`}>
              Sandbox
            </span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={environment === 'production'}
                onChange={(e) => onEnvironmentChange(e.target.checked ? 'production' : 'sandbox')}
              />
              <span className="toggle-slider"></span>
            </label>
            <span className={`env-label ${environment === 'production' ? 'active' : ''}`}>
              Production
            </span>
          </div>
        )}
        
        {/* User Info and Logout (only show if auth is required and user is authenticated) */}
        {authRequired && isAuthenticated && user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: '16px' }}>
            <div style={{ 
              fontSize: '14px', 
              color: '#4a5568',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end'
            }}>
              <span style={{ fontWeight: '500' }}>{user.name}</span>
              <span style={{ fontSize: '12px', color: '#718096' }}>{user.email}</span>
            </div>
            <button 
              className="btn btn-secondary" 
              onClick={logout}
              style={{ 
                padding: '6px 12px',
                fontSize: '14px'
              }}
            >
              Logout
            </button>
          </div>
        )}
        
        {getHeaderActions()}
      </div>
    </div>
  );
};

export default Header;
